import { render, staticRenderFns } from "./ModalEditStudent.vue?vue&type=template&id=40d78e8e&scoped=true&lang=pug&"
import script from "./ModalEditStudent.vue?vue&type=script&lang=ts&"
export * from "./ModalEditStudent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d78e8e",
  null
  
)

export default component.exports